import React from 'react';
import {
  DropDownList,
  DropDownListChangeEvent,
  DropDownListFilterChangeEvent,
  DropDownListOpenEvent
} from '@progress/kendo-react-dropdowns';

// Define the prop types for the component
export interface DropDownProps {
  filterable?: boolean;
  data?: any[];
  onFilterChange?: (event: DropDownListFilterChangeEvent) => void;
  loading?: boolean;
  textField?: string;
  label?: string;
  name?: string;
  value?: any;
  onChange?: (event: DropDownListChangeEvent) => void;
  dataItemKey?: string;
  showExtraPadding?: boolean;
  itemRender?: (li: React.ReactElement, itemProps: any) => React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  required?: boolean;
  defaultValue?: any;
  key?: any;
  disabled?: boolean;
  filter?: string;
  validityStyles?: boolean;
  onOpen?: (event: DropDownListOpenEvent) => void;
  opened?: boolean;
  ariaDescribedBy?: string;
  valueRender?: (element: React.ReactElement, value: any) => React.ReactNode;
}

const DropDownListComponent: React.FC<DropDownProps> = ({
  filterable,
  data,
  onFilterChange,
  loading,
  textField,
  label,
  name,
  value,
  onChange,
  dataItemKey,
  itemRender,
  style,
  className,
  required,
  defaultValue,
  key,
  disabled,
  filter,
  validityStyles,
  onOpen,
  opened,
  ariaDescribedBy,
  valueRender
}) => {
  return (
    <div>
      {label && <label htmlFor={name}>{label}</label>}
      <DropDownList
        filterable={filterable}
        data={data}
        onFilterChange={(event: DropDownListFilterChangeEvent) => {
          onFilterChange?.(event);
        }}
        loading={loading}
        textField={textField}
        name={name}
        value={value}
        onChange={(event: DropDownListChangeEvent) => {
          onChange?.(event);
        }}
        dataItemKey={dataItemKey}
        itemRender={itemRender}
        style={style}
        className={className}
        required={required}
        defaultValue={defaultValue}
        key={key}
        disabled={disabled}
        filter={filter}
        validityStyles={validityStyles}
        onOpen={(event: DropDownListOpenEvent) => {
          onOpen?.(event);
        }}
        opened={opened}
        ariaDescribedBy={ariaDescribedBy}
        valueRender={valueRender}
      />
    </div>
  );
};

export default DropDownListComponent;
